import React from "react";
import { View, TextInput } from "react-native";
import { colors, global } from "../../const";
import { PrimaryCaption, InputAlertTitle } from "../labels";

export default function Input({ title, error, right, style, ...others }) {

    return (
        <>
            <PrimaryCaption>
                {title}
            </PrimaryCaption>

            <View style={{ flexDirection: "row", alignItems: "center" }}>
                <TextInput
                    style={{
                        fontSize: 16,
                        color: colors.midnightBack,
                        fontFamily: global.FONT_REGULAR,
                        flex: 1,
                        borderWidth: 1,
                        borderColor: error ? colors.alert : colors.lightGray,
                        borderRadius: 6,
                        height: 50,
                        paddingHorizontal: 5,
                        paddingRight: right ? 40 : 5,
                        ...style
                    }}
                    {...others}
                />

                {
                    right && (
                        <View style={{
                            position: "absolute",
                            height: 40,
                            width: 40,
                            right: 5,
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            {right}
                        </View>
                    )
                }
            </View>
            {
                error && (
                    <InputAlertTitle>
                        {error}
                    </InputAlertTitle>
                )
            }
        </>
    )
}